import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useIntl } from 'react-intl';
import { closeModal } from 'store/modals/actions';
import { MODAL_SCHEDULER_NO_WS_WARNING } from 'store/modals/modals';
import ConfirmNavigationModal from 'Common/Components/ConfirmNavigationModal';
import { redirect } from 'store/Router/actions';
import { selectSelectedSection } from 'store/Schedule/selectors';
import Redirect from './styled';

const NoWsWarning = () => {
  const intl = useIntl();
  const dispatch = useDispatch();
  const selectedSection = useSelector(selectSelectedSection);
  const title = intl.formatMessage({ id: 'schedule.noWsModal.title' });
  const done = intl.formatMessage({ id: 'schedule.noWsModal.button' });
  const messageId = selectedSection === 'scheduledCloudAgents'
    ? 'schedule.noWsModal.securityScannerMessage'
    : 'schedule.noWsModal.runnerMessage';
  const sectionLabel = 'Runners & Security Scanners';

  const onClick = () => {
    dispatch(redirect('/automation/agents'));
  };

  const onDone = () => {
    dispatch(closeModal(MODAL_SCHEDULER_NO_WS_WARNING));
  };

  return (
    <ConfirmNavigationModal
      title={ title }
      message={ intl.formatMessage(
        { id: messageId },
        { section: <Redirect onClick={ onClick }>{ sectionLabel }</Redirect> }
      ) }
      onDone={ onDone }
      done={ done }
    />
  );
};

export default NoWsWarning;
